import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICardOppositionHistoryFilterFormMeta {
  pan: FormInputMeta;
  oppositionDateFrom: FormInputMeta;
  oppositionDateTo: FormInputMeta;

  schema: any;
}

const cardOppositionHistoryFilterFormMeta = {} as ICardOppositionHistoryFilterFormMeta;

cardOppositionHistoryFilterFormMeta.pan = {
  name: "pan",
  type: "select",
  label: "PAN",
  options: [
    {
      label: "pan 1",
      value: "pan-1"
    },
    {
      label: "pan 2",
      value: "pan-2"
    },
  ],
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

cardOppositionHistoryFilterFormMeta.oppositionDateFrom = {
  name: "oppositionDateFrom",
  type: "date",
  label: "Opposition Date From",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

cardOppositionHistoryFilterFormMeta.oppositionDateTo = {
  name: "oppositionDateTo",
  type: "date",
  label: "Opposition Date To",
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

cardOppositionHistoryFilterFormMeta.schema = yup.object().shape(getValidationSchema(cardOppositionHistoryFilterFormMeta));

export default cardOppositionHistoryFilterFormMeta;